export const getHeaderStyles = ({ palette }) => (
  {
    display: 'grid',
    gridTemplateColumns: '24px minmax(0, min-content) min-content auto max-content 24px',
    gridTemplateRows: 24,
    alignItems: 'center',
    '& .summary-header-icon': {
      gridColumn: '1',
      justifySelf: 'stretch',
      alignSelf: 'center',
      position: 'relative',
      borderRadius: '50%',
      width: 24,
      height: 24,
      '& span': {
        color: palette.white,
        position: 'absolute',
        fontSize: 13,
        left: '25%',
        right: '25%',
        top: '25%',
        bottom: '25%',
      },
    },
    '& .summary-header-title': {
      padding: '0 0 0 10px',
      gridColumn: '2',
      fontSize: 14,
      color: '#323130',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .summary-header-label': {
      alignSelf: 'center',
      marginLeft: 8,
      gridColumn: '3',
      fontSize: 12,
      background: '#EFF6FC',
      border: '1px solid #FFFFFF',
      boxSizing: 'border-box',
      borderRadius: 12,
      width: 48,
      padding: '0 10px 0 10px',
    },
    '& .summary-card-os-tag-container': {
      gridColumn: '5',
      '& .not-available-line': {
        paddingLeft: 10,
        paddingRight: 10,
      },
      '& .iconba.iconba-Trending12': {
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 3,
      },
    },
    '& .summary-header-auto-apply': {
      marginLeft: 8,
      gridColumn: '3',
      height: 20,
      fontSize: '11px',
      lineHeight: '16px',
      borderRadius: '12px',
      backgroundColor: '#F7F7F7',
      padding: '0px 10px',
      display: 'flex',
      alignItems: 'center',

      '& .iconba.iconba-FlashAuto': {
        top: '2px',
      },
    },
    '& .summary-header-menu': {
      gridColumn: '6',
      justifySelf: 'right',
      '& .toggle-context-menu': {
        cursor: 'pointer',
        '& button': {
          background: 'none',
          border: 'none',
          margin: 0,
          padding: 0,
        },
      },
      '& .bingads-popover': {
        right: 5,
      },
    },
    '& .summary-context-menu': {
      '& .bingads-popover': {
        background: '#fff',
        border: '1px solid #ddd',
        boxShadow: '3px 3px 4px #ddd',
        top: 'inherit !important',
        left: 'inherit !important',
        '& >ul': {
          minWidth: 170,
          listStyle: 'none',
          margin: '0',
          padding: '0',
          '& button': {
            margin: '0',
            padding: '7px 10px',
            color: '#333',
            fontWeight: 'normal',
            textAlign: 'left',
            '&[disabled]': {
              opacity: 0.5,
            },
            '&:hover': {
              textDecoration: 'none',
              background: '#e5e5e5',
            },
          },
        },
      },
    },
    '& .new-badge-container': {
      gridColumn: 4,
      justifySelf: 'right',
      marginRight: 8,
    },
  }
);
